import { render, staticRenderFns } from "./alipayInsurance.vue?vue&type=template&id=31b939bd&scoped=true&"
import script from "./alipayInsurance.vue?vue&type=script&lang=js&"
export * from "./alipayInsurance.vue?vue&type=script&lang=js&"
import style0 from "./alipayInsurance.vue?vue&type=style&index=0&id=31b939bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b939bd",
  null
  
)

export default component.exports